var _g, _mask, _path, _path2, _path3, _circle, _circle2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgChatbot = function SvgChatbot(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 101,
    viewBox: "0 0 102 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_238_8740)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 47,
    r: 30,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 47,
    r: 29.5,
    stroke: "#E7E7E7"
  }))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_238_8740",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51 64C58.1797 64 64 58.1797 64 51C64 43.8203 58.1797 38 51 38C43.8203 38 38 43.8203 38 51C38 58.1797 43.8203 64 51 64ZM46.5 50C47.8807 50 49 48.8807 49 47.5C49 46.1193 47.8807 45 46.5 45C45.1193 45 44 46.1193 44 47.5C44 48.8807 45.1193 50 46.5 50ZM58 47.5C58 48.8807 56.8807 50 55.5 50C54.1193 50 53 48.8807 53 47.5C53 46.1193 54.1193 45 55.5 45C56.8807 45 58 46.1193 58 47.5ZM54.5355 56.8284C55.4732 56.0783 56 55.0609 56 54H51H46C46 55.0609 46.5268 56.0783 47.4645 56.8284C48.4021 57.5786 49.6739 58 51 58C52.3261 58 53.5979 57.5786 54.5355 56.8284Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51 64C58.1797 64 64 58.1797 64 51C64 43.8203 58.1797 38 51 38C43.8203 38 38 43.8203 38 51C38 58.1797 43.8203 64 51 64ZM46.5 50C47.8807 50 49 48.8807 49 47.5C49 46.1193 47.8807 45 46.5 45C45.1193 45 44 46.1193 44 47.5C44 48.8807 45.1193 50 46.5 50ZM58 47.5C58 48.8807 56.8807 50 55.5 50C54.1193 50 53 48.8807 53 47.5C53 46.1193 54.1193 45 55.5 45C56.8807 45 58 46.1193 58 47.5ZM54.5355 56.8284C55.4732 56.0783 56 55.0609 56 54H51H46C46 55.0609 46.5268 56.0783 47.4645 56.8284C48.4021 57.5786 49.6739 58 51 58C52.3261 58 53.5979 57.5786 54.5355 56.8284Z",
    fill: "#131F32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56 54H57V53H56V54ZM54.5355 56.8284L53.9108 56.0476H53.9108L54.5355 56.8284ZM46 54V53H45V54H46ZM47.4645 56.8284L46.8398 57.6093H46.8398L47.4645 56.8284ZM63 51C63 57.6274 57.6274 63 51 63V65C58.732 65 65 58.732 65 51H63ZM51 39C57.6274 39 63 44.3726 63 51H65C65 43.268 58.732 37 51 37V39ZM39 51C39 44.3726 44.3726 39 51 39V37C43.268 37 37 43.268 37 51H39ZM51 63C44.3726 63 39 57.6274 39 51H37C37 58.732 43.268 65 51 65V63ZM48 47.5C48 48.3284 47.3284 49 46.5 49V51C48.433 51 50 49.433 50 47.5H48ZM46.5 46C47.3284 46 48 46.6716 48 47.5H50C50 45.567 48.433 44 46.5 44V46ZM45 47.5C45 46.6716 45.6716 46 46.5 46V44C44.567 44 43 45.567 43 47.5H45ZM46.5 49C45.6716 49 45 48.3284 45 47.5H43C43 49.433 44.567 51 46.5 51V49ZM55.5 51C57.433 51 59 49.433 59 47.5H57C57 48.3284 56.3284 49 55.5 49V51ZM52 47.5C52 49.433 53.567 51 55.5 51V49C54.6716 49 54 48.3284 54 47.5H52ZM55.5 44C53.567 44 52 45.567 52 47.5H54C54 46.6716 54.6716 46 55.5 46V44ZM59 47.5C59 45.567 57.433 44 55.5 44V46C56.3284 46 57 46.6716 57 47.5H59ZM55 54C55 54.7145 54.6467 55.4589 53.9108 56.0476L55.1602 57.6093C56.2997 56.6977 57 55.4073 57 54H55ZM51 55H56V53H51V55ZM46 55H51V53H46V55ZM48.0892 56.0476C47.3533 55.4589 47 54.7145 47 54H45C45 55.4073 45.7003 56.6977 46.8398 57.6093L48.0892 56.0476ZM51 57C49.8758 57 48.8308 56.6409 48.0892 56.0476L46.8398 57.6093C47.9735 58.5163 49.472 59 51 59V57ZM53.9108 56.0476C53.1692 56.6409 52.1242 57 51 57V59C52.528 59 54.0265 58.5163 55.1602 57.6093L53.9108 56.0476Z",
    fill: "#131F32",
    mask: "url(#path-3-inside-1_238_8740)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51 39V34",
    stroke: "#131F32",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 32,
    r: 3.5,
    fill: "white",
    stroke: "#131F32"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 32,
    r: 1.5,
    fill: "#159DFF",
    stroke: "#159DFF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_238_8740",
    x: 0,
    y: 0,
    width: 102,
    height: 102,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.120833 0 0 0 0 0.120833 0 0 0 0 0.120833 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_238_8740"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_238_8740",
    result: "shape"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgChatbot);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "Chatbot.35ea5614de8a695f1a55b53f0bfc908b.svg";